import { lookupCountry, } from './countries.js';
/**
 * The {@link CountryCode}s representing countries in which Owner operates. For
 * the complete list of ISO-standard country codes, see {@link COUNTRY_CODES}.
 */
export const OPERATING_COUNTRY_CODES = [
    'US',
    'CA',
];
/**
 * The {@link Country}s in which Owner operates. For the complete list of
 * ISO-standard countries, see {@link COUNTRIES}.
 */
export const OPERATING_COUNTRIES = OPERATING_COUNTRY_CODES.map((x) => lookupCountry(x));
/**
 * Narrows an arbitrary string to an {@link OperatingCountryCode}.
 *
 * @param value the string to check
 * @return true iff the supplied string is a valid `OperatingCountryCode`
 */
export const isOperatingCountryCode = (value) => OPERATING_COUNTRY_CODES.includes(value);
//# sourceMappingURL=operatingCountries.js.map